<template>
    <div>
            <PlayCollection v-on:hide="collectionFinished"  :show=collectionShow :card_data=collectionCard></PlayCollection>
            <PlayAction v-on:hide="actionFinished"  :show=actionShow :card_data=actionCard></PlayAction>


    </div>


</template>

<script>
    import PlayCollection from "../components/PlayCollection"
    import PlayAction from "../components/PlayAction"
    export default {
        name: "Widget",
        components:{
            PlayCollection, PlayAction
        },
        data(){
            return{
                collectionShow:false,
                collectionCard:null,
                actionShow:false,
                actionCard:null,
                queue:[],
                sid:null
            }
        },
        mounted:function(){
            this.sid=this.$route.query.id;
            this.$socket.emit('greeting', this.sid);

        },
        methods:{
            collectionFinished(){
                this.collectionShow=false;
                let self=this;
                setTimeout(function(){
                    self.queue=self.queue.slice(1)
                },1000)


            },
            actionFinished(){
                this.actionShow=false;
                let self=this;
                setTimeout(function(){
                    self.queue=self.queue.slice(1)
                },1000)

            },
            playCard(data){
                if(data.TYPE==="TEST"){
                    this.playTest(data.DATA);
                }
                else if(data.TYPE==="COLLECTION"){
                    this.playCollection(data.DATA);
                }
                else if(data.TYPE==="ACTION"){
                    this.playAction(data.DATA);
                }
            },
            playTest(card){

                this.collectionCard=card;
                this.collectionShow=true;
            },
            playCollection(card){
                this.collectionCard=card;
                this.collectionShow=true;
            },
            playAction(card){
                this.actionCard=card;
                this.actionShow=true;
            }
        },
        watch:{
          queue:function(newQ,oldQ){
              if(newQ.length===1){
                  this.playCard(this.queue[0]);
              }
              else if(newQ.length<oldQ.length && newQ.length>0){
                  this.playCard(this.queue[0]);
              }
          }
        },
        sockets: {
            bump(){
                console.log("RECONNECT!");
                this.$socket.emit('bump', this.sid);
            },
            test_card(data){
                let card=JSON.parse(data);
                card.TYPE="TEST";
                this.queue.push({"TYPE":"TEST","DATA":card})

            },
            collection_card(data){
                let card=JSON.parse(data);
                this.queue.push({"TYPE":"COLLECTION","DATA":card})
            },
            action_card(data){
                let card=JSON.parse(data);
                this.queue.push({"TYPE":"ACTION","DATA":card})

            },
            connected() {

            }}
    }
</script>

<style scoped>

</style>
